module.exports = "<svg id=\"73baab59-544e-4ed2-abd9-b09d2c0187d7\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\"><title>ig</title><circle cx=\"25\" cy=\"25\" r=\"25\"></circle><rect x=\"13.52\" y=\"13.86\" width=\"23.02\" height=\"23.02\" rx=\"5.33\" ry=\"5.33\" style=\"fill: #fff\"></rect><circle class=\"ig-circle\" cx=\"25.02\" cy=\"25.37\" r=\"4.32\" style=\"fill: none;stroke-linecap: round;stroke-miterlimit: 10;stroke-width: 3px\"></circle><circle cx=\"30.63\" cy=\"17.51\" r=\"1.54\"></circle></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ig.svg
// module id = 562
// module chunks = 1